import { Fragment } from 'react';
import { rage } from '~/rage';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { ShopShadow } from '~/components/ui/ShopShadow';

const Background = () => (
	<Fragment>
		{rage.config.isStub() && <BgPlaceholder $type={PlaceholderType.Paint} />}
		<ShopShadow />
	</Fragment>
);

export { Background };
